import React, { Component } from 'react'
import { Collapse, CardBody, Card } from 'reactstrap';
import { Link } from 'react-scroll'
import { NavLink, useLocation } from 'react-router-dom'
import { useLanguage } from '../../contexts/LanguageContext';

class MobileMenu2Inner extends Component {

    state = {
        isMenuShow: false,
        isOpen: 0,
    }

    menuHandler = () => {
        this.setState({
            isMenuShow: !this.state.isMenuShow
        })
    }

    setIsOpen = id => () => {
        this.setState({
            isOpen: id === this.state.isOpen ? 0 : id
        })
    }

    render() {
        const { isMenuShow } = this.state;
        const { t, language, changeLanguage, isHome } = this.props;

        const navItems = [
            { key: 'home',     label: t('nav.home'),     offset: 0 },
            { key: 'couple',   label: t('nav.couple'),   offset: -100 },
            { key: 'location', label: t('nav.location'), offset: -80 },
            { key: 'events',   label: t('nav.events'),   offset: -80 },
            { key: 'RSVP',     label: t('nav.rsvp'),     offset: 0 },
            { key: 'gallery',  label: t('nav.gallery'),  offset: -100 },
        ];

        return (
            <div>
                <div className={`mobileMenu ${isMenuShow ? 'show' : ''}`}>
                    <div className="menu-close">
                        <div className="clox" onClick={this.menuHandler}><i className="ti-close"></i></div>
                    </div>

                    <ul className="responsivemenu">
                        {navItems.map((item) => (
                            <li key={item.key}>
                                {isHome ? (
                                    <Link
                                        activeClass="active"
                                        to={item.key}
                                        spy={true}
                                        smooth={true}
                                        offset={item.offset}
                                        duration={500}
                                        onClick={this.menuHandler}
                                    >
                                        {item.label}
                                    </Link>
                                ) : (
                                    <a href={`/#${item.key}`} onClick={this.menuHandler}>
                                        {item.label}
                                    </a>
                                )}
                            </li>
                        ))}
                    </ul>

                    <div className="mobile-language-selector" style={{ padding: '20px', textAlign: 'center', borderTop: '1px solid rgba(255,255,255,0.1)', marginTop: '20px' }}>
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '12px' }}>
                            <button
                                onClick={() => changeLanguage('hu')}
                                style={{
                                    backgroundColor: language === 'hu' ? 'rgba(255,255,255,.2)' : 'rgba(255,255,255,.1)',
                                    color: '#fff',
                                    width: '50px',
                                    height: '50px',
                                    border: 'none',
                                    borderRadius: '50%',
                                    fontWeight: language === 'hu' ? 'bold' : 'normal',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '16px'
                                }}
                            >
                                HU
                            </button>
                            <button
                                onClick={() => changeLanguage('en')}
                                style={{
                                    backgroundColor: language === 'en' ? 'rgba(255,255,255,.2)' : 'rgba(255,255,255,.1)',
                                    color: '#fff',
                                    width: '50px',
                                    height: '50px',
                                    border: 'none',
                                    borderRadius: '50%',
                                    fontWeight: language === 'en' ? 'bold' : 'normal',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '16px'
                                }}
                            >
                                EN
                            </button>
                        </div>
                    </div>
                </div>

                <div className="showmenu" onClick={this.menuHandler}>
                    <button type="button" className="navbar-toggler open-btn">
                        <span className="icon-bar first-angle"></span>
                        <span className="icon-bar middle-angle"></span>
                        <span className="icon-bar last-angle"></span>
                    </button>
                </div>
            </div>
        )
    }
}

const MobileMenu2 = () => {
    const { t, language, changeLanguage } = useLanguage();
    const location = useLocation();
    const isHome = location.pathname === '/';

    return (
        <MobileMenu2Inner
            t={t}
            language={language}
            changeLanguage={changeLanguage}
            isHome={isHome}
        />
    );
};

export default MobileMenu2;
